import styled from 'styled-components'

type Props = { fontSize?: number | string; count: number }

export const ExploreFilterCount: React.FC<Props> = ({ fontSize, count }) => {
  return <Root $fontSize={fontSize ?? 9}>{count}</Root>
}

const Root = styled.span<{ $fontSize: number | string }>`
  border-radius: 4px;
  color: var(--primary-9);
  background: var(--primaryA-3);
  font-size: ${({ $fontSize }) =>
    typeof $fontSize === 'string' ? $fontSize : `${$fontSize}px`};
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  display: inline-block;
  padding: 0.333em 1ch;

  margin-inline-start: 2px;
`
